



































import {onMounted, Ref, ref} from "@vue/composition-api"
import {env} from "@/environment"
import axios, {AxiosError, AxiosResponse} from "axios"
import router from "@/router"
import AutoComplete from "@/home/AutoComplete.vue"
import Slider from "@/home/Slider.vue"
import Chips from "@/home/Chips.vue"

export default {
  name: 'CreateRoomForm',
  components: {AutoComplete, Slider, Chips},
  setup() {
    const form = ref<{ language: string; capacity: number; tags: { name: string }[] }>({
      language: 'english',
      capacity: 8,
      tags: []
    })
    const tags: Ref<string[]> = ref([])
    const suggestions = ref<string[]>([])
    const open = ref<boolean>(false)
    const isError = ref(false)

    onMounted(async () => {
      const response = await axios.get(`${env.backendUrl}/rooms/languages`)
      suggestions.value.push(...response.data)
    })

    return {

      tags,
      form,
      suggestions,
      open,
      isError,

      onMounted,
      onFormSubmit: () => {
        form.value.tags = tags.value.map(x => ({name: x}))
        axios.post(`${env.backendUrl}/rooms`, open.value ? form.value : {})
          .then((response: AxiosResponse<{id: string}>) => {
            const newRoomUrl = router.resolve(`/rooms/${response.data.id}`).href
            window.open(newRoomUrl, '_blank')
          })
          .catch((error: AxiosError) => {
            isError.value = error.isAxiosError
            throw error
          })
      }
    }
  }
}
